import { AbstractControl, ValidatorFn } from '@angular/forms';

export const rutValidator: ValidatorFn = (control: AbstractControl) => {
  const rawValue = control.value;
  if (!rawValue) return null;

  const cleaned = rawValue.toString().replace(/\./g, '').replace(/\s+/g, '').toUpperCase();
  const match = cleaned.match(/^(\d{7,8})-?([\dK])$/);
  if (!match) return { invalidRut: true };

  const num = match[1];
  const dv = match[2];

  let sum = 0;
  let factor = 2;
  for (let i = num.length - 1; i >= 0; i--) {
    sum += parseInt(num.charAt(i), 10) * factor;
    factor = factor === 7 ? 2 : factor + 1;
  }
  const expected = 11 - (sum % 11);
  let dvExpected = '';
  if (expected === 11) dvExpected = '0';
  else if (expected === 10) dvExpected = 'K';
  else dvExpected = expected.toString();

  return dv === dvExpected ? null : { invalidRut: true };
};
